import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import highlightjs from "highlight.js";
import katex from "katex";
import mermaid from "mermaid";
import { config } from "md-editor-rt";
import "highlight.js/styles/atom-one-light.css";
import "./index.css";
import store from "./store/index";
import { Provider } from "react-redux";
config({
  editorExtensions: {
    highlight: {
      instance: highlightjs,
    },
    katex: {
      instance: katex,
      css: "./markDown/katex.css",
    },
    mermaid: {
      instance: mermaid,
    },
  },
});
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
